import { Link } from 'react-router-dom';

export default function GiveawayButton() {
  return (
    <section className="relative py-20 px-6 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #dc2626 0, #dc2626 1px, transparent 0, transparent 50%)',
          backgroundSize: '10px 10px'
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center">
        {/* Badge */}
        <div className="inline-block mb-6">
          <div className="flex items-center gap-3 px-6 py-3 border-2 border-red-600 bg-red-600/10">
            <i className="ri-gift-line text-3xl text-red-500 w-8 h-8 flex items-center justify-center"></i>
            <span className="text-red-500 font-bold text-lg tracking-widest uppercase">Limited Time Giveaway</span>
          </div>
        </div>

        {/* Headline */}
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 uppercase tracking-tight">
          WIN A DREAM GETAWAY
        </h2>

        {/* Description */}
        <p className="text-xl md:text-2xl text-gray-300 mb-4 leading-relaxed">
          12 lucky winners will receive a 4 days and 3 nights vacation stay
        </p>
        <p className="text-lg text-red-500 font-semibold mb-8 tracking-wide">
          NYC • LAS VEGAS • MIAMI
        </p>

        {/* CTA Button */}
        <Link
          to="/giveaway"
          className="group relative inline-flex px-12 py-5 bg-red-600 hover:bg-red-700 text-white font-bold text-xl tracking-wider transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer overflow-hidden"
        >
          <span className="relative z-10 flex items-center gap-3 justify-center">
            ENTER NOW
            <i className="ri-arrow-right-line text-2xl w-6 h-6 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
          </span>
          <div className="absolute inset-0 bg-gradient-to-r from-red-700 to-red-600 opacity-0 group-hover:opacity-100 transition-opacity"></div>
        </Link>

        {/* Fine Print */}
        <p className="text-gray-500 text-sm mt-6">
          Celebrating Chicago Heartbreak • Winner's choice of destination
        </p>
      </div>
    </section>
  );
}
